import { render, staticRenderFns } from "./shalfSetting.vue?vue&type=template&id=858a30da&"
import script from "./shalfSetting.vue?vue&type=script&lang=js&"
export * from "./shalfSetting.vue?vue&type=script&lang=js&"
import style0 from "./shalfSetting.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports